export const data = [
  {
    name: "Red & White Pill Square",
    url: "/images/red.jpg",
    description: "A group of red and white pills arranged in a square",
    date: "November 2, 2021",
    type: "image/jpg",
    src: "https://unsplash.com/photos/CCFrdCunE4w",
    credit: "Pawel Czerwinski",
  },
  {
    name: "Rolled Paper",
    url: "/images/peach.jpg",
    description: "A close up of a rolled up piece of paper",
    date: "May 8, 2023",
    type: "image/jpg",
    src: "https://unsplash.com/photos/aOOfb645-qQ",
    credit: "ilgmyzin",
  },
  {
    name: "Sunx",
    url: "/images/orange.jpg",
    description: "An abstract red and orange background with curves",
    date: "October 7, 2021",
    type: "image/jpg",
    src: "https://unsplash.com/photos/K-DwbsTXliY",
    credit: "Li Zhang",
  },
  {
    name: "Black and White objects",
    url: "/images/yellow.jpg",
    description: "A black and white object with a white cap and a black cap",
    date: "June 19, 2022",
    type: "image/jpg",
    src: "https://unsplash.com/photos/HivJSjRYJ2o",
    credit: "Galina Nelyubova",
  },
  {
    name: "Glassworks - Green",
    url: "/images/green.jpg",
    description: "A close up of a roll of tape on a green background",
    date: "May 29, 2023",
    type: "image/jpg",
    src: "https://unsplash.com/photos/ydvaP3HZjXk",
    credit: "Planet Volumes",
  },
  {
    name: "Stairs to Tunnel",
    url: "/images/blue.jpg",
    description:
      "A set of stairs leading up to a tunnel, 3D design inspiration from 'chefchaouen City'",
    date: " May 23, 2023",
    type: "image/jpg",
    src: "https://unsplash.com/photos/kYdeqKRBtGw",
    credit: "Mohamed Nohassi",
  },
  {
    name: "Glassmorph study",
    url: "/images/mixed.jpg",
    description: "A group of different colored shapes on a white background",
    date: "May 20, 2023",
    type: "image/jpg",
    src: "https://unsplash.com/photos/6osDWxqr6mk",
    credit: "Don Kaveen",
  },
  {
    name: "Pink",
    url: "/images/violet.jpg",
    description: "A group of pink balls sitting on top of each other",
    date: "2023-22-06",
    type: "image/jpg",
    src: "https://unsplash.com/photos/ycTf5MktHEg",
    credit: "Vighnesh Dudani",
  },
  {
    name: "3D Render",
    url: "/images/mixed1.jpg",
    description: "A 3D rendered image",
    date: " March 31, 2023",
    type: "image/jpg",
    src: "https://unsplash.com/photos/C5f2VvmZae0",
    credit: "Shubham Dhage",
  },
];
